import gql from 'graphql-tag';

export const leadListGQL = gql`
  query (
    $inst_id: String!
    $account_id: String!
    $filters: String
    $sort: String!
    $search: String!
    $page: Int
    $size: Int
  ) {
    paginatedList(
      instId: $inst_id
      accountId: $account_id
      filters: $filters
      sort: $sort
      search: $search
      page: $page
      size: $size
    ) {
      list {
        id
        createdAt
        lastModified: updatedAt
        deletedAt
        name
        instId
        accountId
        system
        shared
        filters
        orderBy
        attributes
        createdBy: createUser
        updateUser
        listType
        leads: count
        loadAttributes
      }
      page
      totalPages
      totalRecords
      totalListsForUser: total_lists_for_user
      recordsPerPage
      prevPage
      nextPage
    }
  }
`;

export const duplicateListGQL = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
  ) {
    listDuplicate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      name: $name
    ) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
        count
      }
      message
      code
    }
  }
`;
